import { useContext } from 'react';

import { SidebarStateContext } from 'contexts/sidebarStateContext';
import { isTqlInboxEmail } from 'utils/quickQuoteDefaults';

// TQL-specific quoting verbiage and defaults key off the signed-in inbox domain.
export function useIsTqlInbox(): boolean {
  const {
    currentState: { inboxEmailAddress },
  } = useContext(SidebarStateContext);

  return isTqlInboxEmail(inboxEmailAddress);
}
